import { WatchlistBaseModel } from '../domain/watchlist/WatchlistDomains';

export type SafeListPubSubAction = 'add' | 'remove';

export interface SafeListPubSubMessage {
  referenceId: string;
  action: SafeListPubSubAction;
  records: WatchlistBaseModel[];
}

type SafeListPubSubListener = (message: SafeListPubSubMessage) => void;

class SafeListPubSub {
  private static readonly CHANNEL_NAME = 'watchlist-safe-list';
  private static channel: BroadcastChannel | undefined;
  private static channelUnavailable: boolean = false;
  private static listeners: Set<SafeListPubSubListener> = new Set();

  public static publish(message: SafeListPubSubMessage): void {
    this.listeners.forEach((listener) => listener(message));
    const channel = this.getChannel();
    if (channel != undefined) {
      channel.postMessage(message);
    }
  }

  public static subscribe(listener: SafeListPubSubListener): () => void {
    this.listeners.add(listener);
    this.getChannel();
    return () => {
      this.listeners.delete(listener);
    };
  }

  private static getChannel(): BroadcastChannel | undefined {
    if (this.channelUnavailable) {
      return undefined;
    }
    if (this.channel != undefined) {
      return this.channel;
    }
    if (typeof BroadcastChannel === 'undefined') {
      this.channelUnavailable = true;
      return undefined;
    }
    try {
      this.channel = new BroadcastChannel(this.CHANNEL_NAME);
      this.channel.onmessage = (event: MessageEvent<SafeListPubSubMessage>) => {
        this.listeners.forEach((listener) => listener(event.data));
      };
      return this.channel;
    } catch {
      this.channelUnavailable = true;
      return undefined;
    }
  }
}

export default SafeListPubSub;
